module.exports = __webpack_public_path__ + "img/weixinzhifu.22445509.png";